/**
 * @module Components.Modals.ModalWrapper
 *
 */
import ModalWrapper from './Modal';

export default ModalWrapper;
